import { render, staticRenderFns } from "./OverviewByAssetChart.vue?vue&type=template&id=06588c9a&scoped=true&"
import script from "./OverviewByAssetChart.vue?vue&type=script&lang=js&"
export * from "./OverviewByAssetChart.vue?vue&type=script&lang=js&"
import style0 from "./OverviewByAssetChart.vue?vue&type=style&index=0&id=06588c9a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06588c9a",
  null
  
)

export default component.exports